const isIsoTargets = (
  targets: Scorecards.IsoTargets | Scorecards.WeekTargets,
): targets is Scorecards.IsoTargets => {
  return targets.mode === 'ISO';
};

export default isIsoTargets;
